import { Box, Grid, Typography } from '@mui/material';
import { useState, useEffect } from 'react';
import { HorizontalForm, LoadingSkeleton, PaginationTable } from '../../../../common/components';
import ProjectAnalyticsCard from './ProjectAnalyticsCard';
import ProjectAnalyticsDetailed from './ProjectAnalyticsDetailed';

/**
 * Grid de análisis de proyectos
 * Muestra proyectos individuales con sus métricas de progreso y calidad
 */
const ProjectAnalyticsGrid = ({ projects, isLoading, viewMode }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  // Calcular proyectos para la página actual
  const startIndex = (currentPage - 1) * rowsPerPage;
  const endIndex = startIndex + rowsPerPage;
  const currentProjects = projects.slice(startIndex, endIndex);
  const totalPages = Math.max(1, Math.ceil(projects.length / rowsPerPage));

  // Resetear página cuando cambien los proyectos (filtros)
  useEffect(() => {
    setCurrentPage(1);
  }, [projects.length, rowsPerPage]);

  useEffect(() => {
    if (currentPage > totalPages) {
      setCurrentPage(totalPages);
    }
  }, [currentPage, totalPages]);
  if (isLoading) {
    return <LoadingSkeleton variant="cards" />;
  }

  if (!projects.length) {
    return (
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        py={6}
        sx={{ bgcolor: 'background.paper', borderRadius: 1 }}
      >
        <Typography variant="h6" color="text.secondary" gutterBottom>
          No se encontraron proyectos
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Ajusta los filtros para ver más resultados
        </Typography>
      </Box>
    );
  }

  return (
    <HorizontalForm variant="twoRows">
      <Typography variant="h5" sx={{ mb: 3, fontWeight: 'bold', color: 'text.primary' }}>
        Análisis Individual de Proyectos ({projects.length})
      </Typography>

      <Grid container spacing={3}>
        {currentProjects.map((project) => (
          <Grid
            item
            xs={12}
            sm={viewMode === 'detailed' ? 12 : 6}
            md={viewMode === 'detailed' ? 12 : 4}
            key={project.uuid}
          >
            {viewMode === 'detailed' ? (
              <ProjectAnalyticsDetailed project={project} />
            ) : (
              <ProjectAnalyticsCard project={project} />
            )}
          </Grid>
        ))}
      </Grid>

      {projects.length > rowsPerPage && (
        <PaginationTable
          sx={{ mt: 2 }}
          totalPages={totalPages}
          totalCount={projects.length}
          page={currentPage}
          rowsPerPage={rowsPerPage}
          onPageChange={(event, value) => setCurrentPage(value)}
          onRowsPerPageChange={(event) => {
            const value = parseInt(event.target.value, 10);
            if (!Number.isNaN(value)) {
              setRowsPerPage(value);
              setCurrentPage(1);
            }
          }}
        />
      )}
    </HorizontalForm>
  );
};

export default ProjectAnalyticsGrid;
